import Vue from 'vue'
import gql from 'graphql-tag'

import createGraphQLClient from '@utils/graphql'

let graphqlClient = null

export const state = {
    objects: {},
    serviceObjects: {}
}

export const getters = {}

export const mutations = {
  SET_BIN_PICKUPS(state, objects) {
    let updatedObjects = {}
    for (let key in objects) {
        if (!objects[key].deleted_at) {
            // Remove the '__typename' field that gets added by GraphQL
            delete objects[key].__typename
            // Stage the update so we can just do one Vue.set
            updatedObjects[objects[key].id] = objects[key]
        } else if (state.objects.hasOwnProperty(objects[key].id)) {
            // Immediately delete the object
            Vue.delete(state.objects, objects[key].id)
        }
    }
    state.objects = {
        ...updatedObjects,
    }
  },
}

export const actions = {
    init({ commit, rootState }) {
        // Initialise the GraphQL client
        graphqlClient = createGraphQLClient(rootState)
    },

    async getBins({ commit }) {
      try {
          await
              graphqlClient.query({
                  query: gql`
                query getBinPickups{
                  bins {
                    id
                    name
                    description
                    capacity
                    price
                    itemcode
                    created_at
                    updated_at
                    deleted_at
                  }
                }
              `,
          }).then((response) => {
              commit('SET_BIN_PICKUPS', response.data.bins)

              return response.data.bins
          })
      } catch (ex) {
          console.error(ex)
          throw ex
      }
    },

    async createBinPickup(
      { commit, dispatch },
      {
        timeCollected,
        pickupNumber,
        collectionId,
        weightCollected,
        serviceBinId,
        defaultWeight,
      } = {}
      ) {
        console.log("Creating Bin Pickups...............")
        try {
          pickupNumber = parseInt(pickupNumber)
          weightCollected = parseFloat(weightCollected)

          return await graphqlClient.mutate({
              mutation: gql`
                  mutation createBinPickup(
                    $TimeCollected: String
                    $PickupNumber: Int
                    $CollectionId: ID
                    $WeightCollected: Float
                    $ServiceBinId: ID
                    $DefaultWeight: Boolean
                    )  {
                      createBinPickup(
                        bin:{
                          pickup_number: $PickupNumber
                          time_collected: $TimeCollected
                          collection_id: $CollectionId
                          weight_collected: $WeightCollected
                          service_bin_id: $ServiceBinId
                          default_weight: $DefaultWeight
                        }
                      ) {
                        id
                    }
                  }
              `,
              variables: { TimeCollected: timeCollected, PickupNumber: pickupNumber, CollectionId: collectionId, WeightCollected: weightCollected, ServiceBinId: serviceBinId, DefaultWeight: defaultWeight },
          }).then((res) => {
            return res
          })
          // dispatch('getBinPickup')
        } catch (ex) {
          console.error(ex)
          throw ex
        }
    },

    async updateBinPickup(
      { commit, dispatch },
      {
        id,
        timeCollected,
        pickupNumber,
        collectionId,
        weightCollected,
        serviceBinId,
        defaultWeight,
      } = {}
    ) {
      try {

        console.log("updating...............")
        // pickupNumber = parseInt(pickupNumber)
        // weightCollected = parseFloat(weightCollected)
        pickupNumber = parseInt(pickupNumber)
        // weightCollected = weightCollected
        // id = 152
        id = parseInt(id)
        return await graphqlClient.mutate({
            mutation: gql`
                mutation updateBinPickup(
                  $Id: Int
                  $TimeCollected: String
                  $PickupNumber: Int
                  $CollectionId: ID
                  $WeightCollected: Float
                  $ServiceBinId: ID
                  $DefaultWeight: Boolean
                )  {
                  updateBinPickup(
                    id: $Id
                    bin:{
                      pickup_number: $PickupNumber
                      time_collected: $TimeCollected
                      collection_id: $CollectionId
                      weight_collected: $WeightCollected
                      service_bin_id: $ServiceBinId
                      default_weight: $DefaultWeight
                    }
                  ) {
                    id
                  }
                }
                `,
            variables: { Id: id, TimeCollected: timeCollected, PickupNumber: pickupNumber, CollectionId: collectionId, WeightCollected: weightCollected, ServiceBinId: serviceBinId, DefaultWeight: defaultWeight},
        }).then((response) => {
          console.log("Update response: ", response)
          return response
          // commit('SET_BINS', response.data.updateBin)
        })
      } catch (ex) {
          console.error(ex)
          throw ex
      }
    },

}
